import * as React from 'react';
import {
    borderCurve,
    LabelRegular,
    redactPrivate,
    Shadows,
    View,
    XStack,
    YStack,
} from 'smoothie';

import {
    CARD_ASPECT_RATIO,
    CardDataType,
    type CardDetailsProps,
} from '../../../types/Card';
import { useCopiedToast } from '../../details-tile/DetailsTile';
import CardData from './CardData';

const CardDetails = ({ cardId, width, ...props }: CardDetailsProps) => {
    const height = width / CARD_ASPECT_RATIO;
    const { showCopiedToast } = useCopiedToast();

    return (
        <YStack
            backgroundColor="$white"
            style={{ ...Shadows.SMALL }}
            borderWidth={1}
            borderColor="$gray200"
            width={width}
            height={height}
            borderRadius={12}
            paddingTop={16}
            paddingBottom={12}
            paddingHorizontal={20}
            justifyContent="space-between"
            overflow="hidden"
            {...redactPrivate()}
            {...borderCurve('continuous')}
            {...props}
        >
            <YStack flex={1} justifyContent="space-between">
                <YStack gap={8}>
                    <LabelRegular>Card Number</LabelRegular>
                    <View height={30}>
                        <CardData
                            cardDataType={CardDataType.COPY_PAN}
                            cardId={cardId}
                            onCopy={showCopiedToast}
                        />
                    </View>
                </YStack>
                <XStack justifyContent="space-between">
                    <YStack gap={8}>
                        <LabelRegular>Exp</LabelRegular>
                        <View height={30} width={90}>
                            <CardData
                                cardDataType={CardDataType.COPY_EXP}
                                cardId={cardId}
                                onCopy={showCopiedToast}
                            />
                        </View>
                    </YStack>
                    <YStack gap={8}>
                        <LabelRegular>CVV</LabelRegular>
                        <View height={30} width={70}>
                            <CardData
                                cardDataType={CardDataType.COPY_CVV}
                                cardId={cardId}
                                onCopy={showCopiedToast}
                            />
                        </View>
                    </YStack>
                </XStack>
            </YStack>
        </YStack>
    );
};

export default CardDetails;
